import { useAtomValue } from 'jotai'

import { NumberFieldInput } from '@sequencehq/core-components'
import { invoiceCurrencySymbolAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { useCurrencyFormatting } from '../hooks/useCurrencyFormatting'
import { RateDisplay } from 'Invoices/types'

type Props = {
  value: string
  isDisabled?: boolean
  onChange: (value: string) => void
  rateDisplay: RateDisplay
  autoFocus?: boolean
  isInvalid: boolean
  'data-testid'?: string
}

export const RateField = ({
  value,
  isDisabled = false,
  onChange,
  rateDisplay,
  autoFocus = false,
  isInvalid,
  'data-testid': dataTestId
}: Props) => {
  const currencySymbol = useAtomValue(invoiceCurrencySymbolAtom)

  const { handleBlur } = useCurrencyFormatting({
    value,
    onChange,
    rateDisplay,
    formatType: rateDisplay === 'ABSOLUTE' ? 'currency' : 'percentage'
  })

  return (
    <NumberFieldInput
      textAlign="right"
      value={value}
      autoFocus={autoFocus}
      data-testid={dataTestId}
      {...(isDisabled
        ? { isDisabled: true }
        : {
            placeholder: rateDisplay === 'ABSOLUTE' ? '0.00' : '0',
            prefix: rateDisplay === 'ABSOLUTE' ? currencySymbol : '%',
            onChange: e => onChange(e.target.value),
            onBlur: handleBlur,
            isInvalid
          })}
    />
  )
}
